import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";
import DriveEndType from "../../enums/drive-end-type";

export default class PeriodStart extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.StartPeriod;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        gameContext.startPeriod();
        gameContext.gameClock.setSeconds(fragment.periodLengthInSeconds);
        gameContext.triggerSwapTeams = true;
        gameContext.triggerNewPeriodNotification = true;

        const startOfSecondHalf = gameContext.isStartOfSecondHalf(
            fragment.period
        );
        if (startOfSecondHalf) {
            gameContext.toggleSecondHalfPossession();
            gameContext.setDriveContext({
                previousDriveEndType: DriveEndType.Halftime
            });
        }

        const otPeriod = gameContext.getOvertimePeriod();
        if (otPeriod) {
            gameContext.setOvertimeNotification({
                period: otPeriod,
                notified: false
            });
            gameContext.triggerKO = false;
            gameContext.fbOtDisabled =
                !gameContext.gameConfig.general.otTimeControl;
            if (otPeriod === 1) {
                gameContext.setCoinTossRequired(true);
            }
        }

        if (startOfSecondHalf || otPeriod) {
            ruleContext.setResetField(true);
        }
    }
}
